// import React, { useState, useEffect, useRef } from "react";
// import {
//     Box, CardHeader, CardContent, Typography, Button, Grid, IconButton, Paper, Chip,
//     Switch, alpha, useTheme, Alert, Snackbar,
//     Card, Table, TableContainer, TableHead, TableBody, TableRow, TableCell,
//     Avatar,
//     Tooltip,
//     Stack,
//     Divider,
//     Badge,
// } from "@mui/material";
// import {
//     Image as ImageIcon, Assessment as AssessmentIcon,PhotoSizeSelectActual as SizeIcon,
//     Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Save as SaveIcon, QrCode as QrCodeIcon,
//     Cancel as CancelIcon, Inventory as InventoryIcon, Print as PrintIcon, LocalOffer as LocalOfferIcon
// } from "@mui/icons-material";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { useReactToPrint } from "react-to-print";

// import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../Components/Select/WSSelect";
// import WSRadioField from "../../Components/Radio/WSRadio";

// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import WSButton from "../../Components/Button/WSButton";
// import { useProduct } from "../../hooks/useProduct";
// import VariantDialog from "./Variant";
// import { WSHeaderCard } from "../../Components/View/HeaderCard";
// import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
// import BarcodePrintLabel from "../../Components/BarCode/BarCodePrintLabel";

// const Product: React.FC = () => {
//     const theme = useTheme();
//     const navigate = useNavigate();

//     const { id } = useParams<{ id: string }>();
//     const isEditMode = Boolean(id);

//     const imageRef = useRef<HTMLInputElement>(null);

//     const [printData, setPrintData] = useState<any>(null);

//     const printRef = useRef<HTMLDivElement>(null);

//     const handlePrint = useReactToPrint({
//         contentRef: printRef
//     });

//     const [variantDialogOpen, setVariantDialogOpen] = useState(false);
//     const [editingVariant, setEditingVariant] = useState<any>(null);
//     const [variants, setVariants] = useState<any[]>([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' | 'info' | 'warning' });

//     const { createProduct, updateProduct, getProduct, loading } = useProduct();

//     const formMethods = useForm({
//         mode: "onChange",
//         defaultValues: {
//             name: "", item_code: "", item_type: "product", category_id: "", brand: "", unit: "",
//             hsn_sac: "", tax_type: "GST", gst_percent: 0, cess_percent: 0,
//             purchase_price: 0, sale_price: 0, mrp: 0, min_sale_price: 0,
//             track_stock: true, allow_negative_stock: false, reorder_level: 0,
//             has_variants: false, image_url: "", notes: "", status: "active",
//             ItemImage: null as FileList | null,
//         },
//     });

//     const { control, handleSubmit, watch, setValue, getValues, reset, formState: { isDirty, isValid } } = formMethods;
//     const hasVariants = watch('has_variants');

//     useEffect(() => {
//         if (isEditMode && id) {
//             fetchProductDetails(id);
//         }
//     }, [id]);

//     const fetchProductDetails = async (productId: string) => {
//         try {
//             const product = await getProduct(productId);
//             reset(product);
//             if (product.variants) {
//                 setVariants(product.variants);
//             }
//         } catch (error) {
//             showSnackbar('Failed to fetch product details', 'error');
//         }
//     };

//     const showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
//         setSnackbar({ open: true, message, severity });
//     };

//     const handleSaveAndPrint = () => {
//         // setPrintAfterSave(true);
//         handleSubmit(() => onSubmit({}, true))();
//     };

//     const onSubmit = async (data: any, isPrint = false) => {
//         try {
//             const formData = new FormData();

//             // 1. BASIC FIELDS - WORKING (keep exactly as before)
//             formData.append("Name", data.name || "");
//             formData.append("ItemCode", data.item_code || "");
//             formData.append("ItemTypeNew", "1");
//             formData.append("CategoryId", data.category_id);
//             formData.append("Brand", data.brand || "");
//             formData.append("Unit", data.unit || "");
//             formData.append("HsnSac", data.hsn_sac || "");
//             formData.append("TaxType", "1");
//             formData.append("GstPercent", data.gst_percent?.toString() || "0");
//             formData.append("CessPercent", data.cess_percent?.toString() || "0");
//             formData.append("PurchasePrice", data.purchase_price?.toString() || "0");
//             formData.append("SalePrice", data.sale_price?.toString() || "0");
//             formData.append("Mrp", data.mrp?.toString() || "0");
//             formData.append("MinSalePrice", data.min_sale_price?.toString() || "0");
//             formData.append("TrackStock", data.track_stock.toString());
//             formData.append("AllowNegativeStock", data.allow_negative_stock.toString());
//             formData.append("ReorderLevel", data.reorder_level?.toString() || "0");
//             formData.append("HasVariants", data.has_variants.toString());
//             formData.append("Notes", data.notes || "");
//             formData.append("Status", "1");

//             // 2. IMAGE UPLOAD - FULL FALLBACK SYSTEM (RESTORED)
//             let imageFile: File | null = null;

//             // Method 1: Direct ref (primary)
//             if (imageRef.current?.files?.[0]) {
//                 imageFile = imageRef.current.files[0];
//             }

//             // Method 2: Form values fallback
//             if (!imageFile) {
//                 const formImage = getValues('ItemImage') as FileList | File | null;
//                 if (formImage && (formImage as FileList)[0]) {
//                     imageFile = (formImage as FileList)[0];
//                 }
//             }

//             // Method 3: DOM query fallback (CRITICAL)
//             if (!imageFile) {
//                 const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
//                 if (fileInput?.files?.[0]) {
//                     imageFile = fileInput.files[0];
//                 }
//             }

//             if (imageFile) {
//                 formData.append("ImageUrl", imageFile);
//             }

//             if (data.has_variants && variants.length > 0) {
//                 variants.forEach((v: any, index: number) => {

//                     formData.append(`Variants[${index}].VariantCode`, v.variant_code || "");
//                     formData.append(`Variants[${index}].Size`, v.size || "");
//                     formData.append(`Variants[${index}].Color`, v.color || "");
//                     formData.append(`Variants[${index}].StockQty`, v.stock_qty || "");
//                     formData.append(`Variants[${index}].Other1`, v.other1 || "");
//                     formData.append(
//                         `Variants[${index}].Status`,
//                         v.status === "active" ? "Active" : "Inactive"
//                     );
//                 });
//             }

//             let response;

//             // 5. API CALLS (unchanged - working)
//             if (isEditMode && id) {

//                 response = await updateProduct(id, formData);
//                 showSnackbar("Product updated successfully", "success");

//             } else {

//                 response = await createProduct(formData);

//                 const barcode = (response as any)?.data?.barcode;
//                 const name = (response as any)?.data?.productName;

//                 showSnackbar("Product created successfully", "success");

//                 if (barcode) {
//                     setPrintData({
//                         barcode,
//                         name
//                     });

//                     setTimeout(() => {
//                         handlePrint();
//                     }, 300);
//                 }
//             }

//             // if (response.success) {

//             //     // Check which action to perform
//             //     if (isPrint) {
//             //         handlePrint(request);
//             //     }
//             //     // else {
//             //     //     navigate('/products/list');
//             //     // }
//             // }

//         } catch (error: any) {
//             console.error("SUBMIT ERROR:", error);
//             showSnackbar(error.response?.data?.message || "Failed to save product", "error");
//         }
//     };


//     const handleAddVariant = () => {
//         setEditingVariant(null);
//         setVariantDialogOpen(true);
//     };

//     const handleEditVariant = (variant: any) => {
//         setEditingVariant(variant);
//         setVariantDialogOpen(true);
//     };

//     const handleDeleteVariant = (variantCode: string) => {
//         setVariants(variants.filter(v => v.variant_code !== variantCode));
//         showSnackbar('Variant deleted', 'info');
//     };

//     const handleSaveVariant = (variantData: any) => {
//         if (editingVariant) {
//             setVariants(variants.map(v => v.variant_code === editingVariant.variant_code ? variantData : v));
//             showSnackbar('Variant updated', 'success');
//         } else {
//             const newVariant = { ...variantData, variant_code: `V${Date.now()}` };
//             setVariants([...variants, newVariant]);
//             showSnackbar('Variant added', 'success');
//         }
//         setVariantDialogOpen(false);
//         setEditingVariant(null);
//     };

//     const categorySource = {
//         url: "Vyapar/Category/search",
//         page: 1,
//         pageSize: 100000,
//         filter: [],
//         sort: []
//     };

//     const transFormData = (data: any) => {
//         return data.map((item: any) => ({
//             label: item.categoryName,
//             value: item.id
//         }));
//     };

//     return (
//         <Box sx={{ p: 3 }}>
//             <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
//                 <WSHeaderCard
//                     header={isEditMode ? 'Edit Product' : 'Add New Product'}
//                     subHeader="Manage product information and variants"
//                     showBackButton={true}
//                     gradient={true}
//                     actions={
//                         <>
//                             <WSButton
//                                 id="cancelBtn"
//                                 variant="outlined"
//                                 color="error"
//                                 size="small"
//                                 label="Cancel"
//                                 startIcon={<CancelIcon />}
//                                 onClick={() => navigate('/products/list')}
//                             />

//                             <WSButton
//                                 id="saveAndPrintBtn"
//                                 variant="contained"
//                                 color="secondary"
//                                 size="small"
//                                 startIcon={<PrintIcon />}
//                                 label="Save & Print"
//                                 onClick={handleSaveAndPrint}
//                             />

//                             <WSButton
//                                 id="saveBtn"
//                                 variant="contained"
//                                 color="primary"
//                                 size="small"
//                                 type="submit"
//                                 startIcon={<SaveIcon />}
//                                 loading={loading}
//                                 label={'Save'}
//                             />
//                         </>
//                     }
//                 />

//                 <Grid container spacing={3}>
//                     {/* Left Column - Main Product Information */}
//                     <Grid item xs={12} lg={8}>
//                         {/* Product Information Card */}
//                         <Card
//                             elevation={0}
//                             sx={{
//                                 mb: 3,
//                                 borderRadius: 3,
//                                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                             }}
//                         >
//                             <CardHeader
//                                 title={
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), width: 32, height: 32 }}>
//                                             <LocalOfferIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
//                                         </Avatar>
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Information</Typography>
//                                     </Box>
//                                 }
//                                 sx={{
//                                     borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                     bgcolor: alpha(theme.palette.background.default, 0.5),
//                                     py: 2,
//                                 }}
//                             />
//                             <CardContent sx={{ p: 3 }}>
//                                 <Grid container spacing={3}>
//                                     {/* Product Name & SKU */}
//                                     <Grid item xs={12} md={6}>
//                                         <WSTextField
//                                             id="name-field"
//                                             name="name"
//                                             rules={{ required: "Product name is required" }}
//                                             label="Product Name"
//                                             control={control}

//                                             sx={{
//                                                 '& .MuiOutlinedInput-root': {
//                                                     borderRadius: 2,
//                                                     '&:hover': {
//                                                         '& .MuiOutlinedInput-notchedOutline': {
//                                                             borderColor: theme.palette.primary.main,
//                                                         },
//                                                     },
//                                                 },
//                                             }}
//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={6}>
//                                         <WSTextField
//                                             id="item-code-field"
//                                             name="item_code"
//                                             rules={{ required: "Item code is required" }}
//                                             label="Item Code / SKU"
//                                             control={control}
//                                             suffix={<QrCodeIcon sx={{ color: theme.palette.text.secondary, mr: 1, fontSize: 20 }} />}
//                                             sx={{
//                                                 '& .MuiOutlinedInput-root': {
//                                                     borderRadius: 2,
//                                                 },
//                                             }}
//                                         />
//                                     </Grid>

//                                     {/* Item Type & Category */}
//                                     <Grid item xs={12} md={6}>
//                                         <WSSelectField
//                                             id="item-type-field"
//                                             name="item_type"
//                                             label="Item Type"
//                                             control={control}
//                                             options={[
//                                                 { value: "product", label: "Product" },
//                                                 // { value: "service", label: "Service" },
//                                                 // { value: "bundle", label: "Bundle" },
//                                             ]}
//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={6}>
//                                         <WSSelectField
//                                             id="category-field"
//                                             name="category_id"
//                                             label="Category"
//                                             control={control}
//                                             source={categorySource}
//                                             transFormData={transFormData}
//                                         />
//                                     </Grid>

//                                     {/* Brand & Unit */}
//                                     <Grid item xs={12} md={6}>
//                                         <WSTextField
//                                             id="brand-field"
//                                             name="brand"
//                                             label="Brand"
//                                             control={control}
//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={6}>
//                                         <WSTextField
//                                             id="unit-field"
//                                             name="unit"
//                                             label="Unit (PCS, KG, Meter)"
//                                             control={control}
//                                         />
//                                     </Grid>

//                                     {/* HSN & Tax Information */}
//                                     <Grid item xs={12}>
//                                         <Divider sx={{ my: 2 }}>
//                                             <Chip
//                                                 label="Tax Information"
//                                                 size="small"
//                                                 sx={{
//                                                     bgcolor: alpha(theme.palette.primary.main, 0.1),
//                                                     color: theme.palette.primary.main,
//                                                     fontWeight: 500,
//                                                 }}
//                                             />
//                                         </Divider>
//                                     </Grid>

//                                     <Grid item xs={12} md={4}>
//                                         <WSTextField
//                                             id="hsn-sac-field"
//                                             name="hsn_sac"
//                                             label="HSN / SAC Code"
//                                             control={control}
//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={4}>
//                                         <WSRadioField
//                                             id="tax-type-field"
//                                             name="tax_type"
//                                             label="Tax Type"
//                                             control={control}
//                                             rules={{ required: true }}
//                                             options={[
//                                                 { value: "GST", label: "GST" },
//                                                 { value: "EXEMPT", label: "Exempt" },
//                                                 { value: "NON_GST", label: "Non-GST" },
//                                                 { value: "NIL", label: "NIL" },
//                                             ]}
//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={4}>
//                                         <WSTextField
//                                             id="gst-percent-field"
//                                             name="gst_percent"
//                                             label="GST Percentage"
//                                             type={TextType.Number}
//                                             control={control}
//                                             rules={{ min: 0, max: 100 }}
//                                             suffix={"%"}
//                                         />
//                                     </Grid>

//                                     {/* Pricing Information */}
//                                     <Grid item xs={12}>
//                                         <Divider sx={{ my: 2 }}>
//                                             <Chip
//                                                 label="Pricing Information"
//                                                 size="small"
//                                                 sx={{
//                                                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                                                     color: theme.palette.success.main,
//                                                     fontWeight: 500,
//                                                 }}
//                                             />
//                                         </Divider>
//                                     </Grid>

//                                     <Grid item xs={12} md={3}>
//                                         <WSTextField
//                                             id="purchase-price-field"
//                                             name="purchase_price"
//                                             label="Purchase Price"
//                                             type={TextType.Currency}
//                                             currency={CurrencyType.Rupee}
//                                             control={control}
//                                             rules={{ required: true, min: 0 }}

//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={3}>
//                                         <WSTextField
//                                             id="sale-price-field"
//                                             name="sale_price"
//                                             label="Sale Price"
//                                             type={TextType.Currency}
//                                             currency={CurrencyType.Rupee}
//                                             control={control}
//                                             rules={{ required: "Sale Price is required", min: 0 }}

//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={3}>
//                                         <WSTextField
//                                             id="mrp-field"
//                                             name="mrp"
//                                             label="MRP"
//                                             type={TextType.Currency}
//                                             currency={CurrencyType.Rupee}
//                                             control={control}
//                                             rules={{ required: "MRP is required", min: 0 }}

//                                         />
//                                     </Grid>
//                                     <Grid item xs={12} md={3}>
//                                         <WSTextField
//                                             id="min-sale-price-field"
//                                             name="min_sale_price"
//                                             label="Min Sale Price"
//                                             type={TextType.Currency}
//                                             currency={CurrencyType.Rupee}
//                                             control={control}
//                                             rules={{ required: true, min: 0 }}
//                                         />
//                                     </Grid>
//                                 </Grid>
//                             </CardContent>
//                         </Card>

//                         {/* Additional Information Card */}
//                         <Card
//                             elevation={0}
//                             sx={{
//                                 borderRadius: 3,
//                                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                             }}
//                         >
//                             <CardHeader
//                                 title={
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <Avatar sx={{ bgcolor: alpha(theme.palette.info.main, 0.1), width: 32, height: 32 }}>
//                                             <AssessmentIcon sx={{ color: theme.palette.info.main, fontSize: 18 }} />
//                                         </Avatar>
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>Additional Information</Typography>
//                                     </Box>
//                                 }
//                                 sx={{
//                                     borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                     bgcolor: alpha(theme.palette.background.default, 0.5),
//                                     py: 2,
//                                 }}
//                             />
//                             <CardContent sx={{ p: 3 }}>
//                                 <WSTextAreaField
//                                     id="notes-field"
//                                     name="notes"
//                                     label="Notes"
//                                     rows={4}
//                                     control={control}
//                                 />
//                             </CardContent>
//                         </Card>
//                     </Grid>

//                     {/* Right Column - Status, Image, Variants */}
//                     <Grid item xs={12} lg={4}>
//                         {/* Status Card */}
//                         <Card
//                             elevation={0}
//                             sx={{
//                                 mb: 3,
//                                 borderRadius: 3,
//                                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                             }}
//                         >
//                             <CardContent sx={{ p: 3 }}>
//                                 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <Badge color="success" variant="dot" />
//                                     Product Status
//                                 </Typography>
//                                 <WSRadioField
//                                     id="status-field"
//                                     name="status"
//                                     control={control}
//                                     rules={{ required: true }}
//                                     options={[
//                                         { value: "active", label: "Active" },
//                                         { value: "inactive", label: "Inactive" },
//                                     ]}

//                                 />
//                             </CardContent>
//                         </Card>

//                         {/* Image Upload Card */}
//                         <Card
//                             elevation={0}
//                             sx={{
//                                 mb: 3,
//                                 borderRadius: 3,
//                                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                             }}
//                         >
//                             <CardContent sx={{ p: 3 }}>
//                                 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <ImageIcon sx={{ color: theme.palette.primary.main }} />
//                                     Product Image
//                                 </Typography>
//                                 <WSImageUpload
//                                     control={control}
//                                     id="ItemImage"
//                                     name="ItemImage"
//                                     label="Click to upload image"
//                                     rules={{ required: false }}
//                                 />
//                             </CardContent>
//                         </Card>

//                         {/* Variants Toggle Card */}
//                         <Card
//                             elevation={0}
//                             sx={{
//                                 borderRadius: 3,
//                                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                                 bgcolor: hasVariants ? alpha(theme.palette.primary.main, 0.02) : 'transparent',
//                             }}
//                         >
//                             <CardContent sx={{ p: 3 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                                     <Box>
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Variants</Typography>
//                                         <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//                                             Enable for products with size, color, etc.
//                                         </Typography>
//                                     </Box>
//                                     <Switch
//                                         checked={hasVariants}
//                                         onChange={(e) => setValue('has_variants', e.target.checked)}
//                                         color="primary"
//                                         sx={{
//                                             '& .MuiSwitch-switchBase.Mui-checked': {
//                                                 color: theme.palette.primary.main,
//                                             },
//                                             '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
//                                                 backgroundColor: alpha(theme.palette.primary.main, 0.5),
//                                             },
//                                         }}
//                                     />
//                                 </Box>
//                             </CardContent>
//                         </Card>
//                     </Grid>

//                     {/* Variants Section */}
//                     {hasVariants && (
//                         <Grid item xs={12}>
//                             <Card
//                                 elevation={0}
//                                 sx={{
//                                     borderRadius: 3,
//                                     border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                     overflow: 'hidden',
//                                     boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                                     mt: 2,
//                                 }}
//                             >
//                                 <CardHeader
//                                     title={
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <Avatar sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), width: 32, height: 32 }}>
//                                                 <InventoryIcon sx={{ color: theme.palette.secondary.main, fontSize: 18 }} />
//                                             </Avatar>
//                                             <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Variants</Typography>
//                                         </Box>
//                                     }
//                                     action={
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             startIcon={<AddIcon />}
//                                             onClick={handleAddVariant}
//                                             size="small"
//                                             sx={{
//                                                 borderRadius: 2,
//                                                 textTransform: 'none',
//                                                 fontWeight: 600,
//                                                 boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
//                                                 '&:hover': {
//                                                     transform: 'translateY(-1px)',
//                                                     boxShadow: `0 6px 15px ${alpha(theme.palette.primary.main, 0.3)}`,
//                                                 },
//                                             }}
//                                         >
//                                             Add Variant
//                                         </Button>
//                                     }
//                                     sx={{
//                                         borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                                         bgcolor: alpha(theme.palette.background.default, 0.5),
//                                         py: 2,
//                                     }}
//                                 />
//                                 <CardContent sx={{ p: 3 }}>
//                                     {variants.length > 0 ? (
//                                         <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
//                                             <Table>
//                                                 <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
//                                                     <TableRow>
//                                                         <TableCell>Variant Code</TableCell>
//                                                         <TableCell>Size</TableCell>
//                                                         <TableCell>Color</TableCell>
//                                                         <TableCell>Other Attribute</TableCell>
//                                                         <TableCell align="center">Status</TableCell>
//                                                         <TableCell align="center">Actions</TableCell>
//                                                     </TableRow>
//                                                 </TableHead>
//                                                 <TableBody>
//                                                     {variants.map((row: any, index: number) => (
//                                                         <TableRow key={row.variant_code || index} hover>
//                                                             <TableCell>
//                                                                 <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                                                                     {row.variant_code}
//                                                                 </Typography>
//                                                             </TableCell>
//                                                             <TableCell>
//                                                                 <Chip
//                                                                     icon={<SizeIcon fontSize="small" />}
//                                                                     label={row.size || 'N/A'}
//                                                                     size="small"
//                                                                     variant="outlined"
//                                                                     sx={{ borderRadius: 1 }}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell>
//                                                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                                     {row.color && (
//                                                                         <Box
//                                                                             sx={{
//                                                                                 width: 16,
//                                                                                 height: 16,
//                                                                                 borderRadius: '50%',
//                                                                                 bgcolor: row.color.toLowerCase(),
//                                                                                 border: '1px solid #ccc',
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                     <Typography variant="body2">{row.color || 'N/A'}</Typography>
//                                                                 </Box>
//                                                             </TableCell>
//                                                             <TableCell>
//                                                                 <Typography variant="body2">{row.other1 || 'N/A'}</Typography>
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <Chip
//                                                                     label={row.status}
//                                                                     color={row.status === 'active' ? 'success' : 'default'}
//                                                                     size="small"
//                                                                     sx={{
//                                                                         minWidth: 60,
//                                                                         fontWeight: 500,
//                                                                     }}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <Stack direction="row" spacing={1} justifyContent="center">
//                                                                     <Tooltip title="Edit Variant">
//                                                                         <IconButton
//                                                                             size="small"
//                                                                             onClick={() => handleEditVariant(row)}
//                                                                             sx={{
//                                                                                 color: theme.palette.primary.main,
//                                                                                 '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.1) }
//                                                                             }}
//                                                                         >
//                                                                             <EditIcon fontSize="small" />
//                                                                         </IconButton>
//                                                                     </Tooltip>
//                                                                     <Tooltip title="Delete Variant">
//                                                                         <IconButton
//                                                                             size="small"
//                                                                             color="error"
//                                                                             onClick={() => handleDeleteVariant(row.variant_code)}
//                                                                             sx={{
//                                                                                 '&:hover': { bgcolor: alpha(theme.palette.error.main, 0.1) }
//                                                                             }}
//                                                                         >
//                                                                             <DeleteIcon fontSize="small" />
//                                                                         </IconButton>
//                                                                     </Tooltip>
//                                                                 </Stack>
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     ))}
//                                                 </TableBody>
//                                             </Table>
//                                         </TableContainer>
//                                     ) : (
//                                         <Paper
//                                             sx={{
//                                                 p: 6,
//                                                 textAlign: 'center',
//                                                 bgcolor: alpha(theme.palette.primary.main, 0.02),
//                                                 borderRadius: 2,
//                                             }}
//                                         >
//                                             <Avatar
//                                                 sx={{
//                                                     width: 80,
//                                                     height: 80,
//                                                     bgcolor: alpha(theme.palette.primary.main, 0.1),
//                                                     mx: 'auto',
//                                                     mb: 2,
//                                                 }}
//                                             >
//                                                 <InventoryIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
//                                             </Avatar>
//                                             <Typography variant="h6" color="text.secondary" gutterBottom>
//                                                 No Variants Added
//                                             </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400, mx: 'auto' }}>
//                                                 Add variants for products that come in different sizes, colors, or other attributes.
//                                             </Typography>
//                                             <Button
//                                                 variant="contained"
//                                                 startIcon={<AddIcon />}
//                                                 onClick={handleAddVariant}
//                                                 sx={{
//                                                     borderRadius: 2,
//                                                     textTransform: 'none',
//                                                     fontWeight: 600,
//                                                 }}
//                                             >
//                                                 Add First Variant
//                                             </Button>
//                                         </Paper>
//                                     )}
//                                 </CardContent>
//                             </Card>
//                         </Grid>
//                     )}
//                 </Grid>
//             </form>

//             <VariantDialog
//                 open={variantDialogOpen}
//                 onClose={() => setVariantDialogOpen(false)}
//                 onSave={handleSaveVariant}
//                 editData={editingVariant}
//             />

//             <div style={{ display: "none" }}>
//                 {printData && (
//                     <BarcodePrintLabel
//                         ref={printRef}
//                         barcode={printData.barcode}
//                         name={printData.name}
//                     />
//                 )}
//             </div>

//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{ width: '100%' }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default Product;








import React, { useState, useEffect, useRef } from "react";
import {
    Box, CardHeader, CardContent, Typography, Button, Grid, IconButton, Paper, Chip,
    Switch, alpha, useTheme, Alert, Snackbar,
    Card, Table, TableContainer, TableHead, TableBody, TableRow, TableCell,
    Avatar,
    Tooltip,
    Stack,
    Divider,
    Badge,
} from "@mui/material";
import {
    Image as ImageIcon, Assessment as AssessmentIcon, PhotoSizeSelectActual as SizeIcon,
    Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Save as SaveIcon, QrCode as QrCodeIcon,
    Cancel as CancelIcon, Inventory as InventoryIcon, Print as PrintIcon, LocalOffer as LocalOfferIcon
} from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import WSRadioField from "../../Components/Radio/WSRadio";

import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSButton from "../../Components/Button/WSButton";
import { useProduct } from "../../hooks/useProduct";
import VariantDialog from "./Variant";
import { WSHeaderCard } from "../../Components/View/HeaderCard";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import BarcodePrintLabel from "../../Components/BarCode/BarCodePrintLabel";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import config from '../../Config/config.json'
import CategoryModal from "./CategoryModal";
import { useLocation } from "react-router-dom";

const Product: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const { id } = useParams<{ id: string }>();
    const isEditMode = Boolean(id);

    const imageRef = useRef<HTMLInputElement>(null);

    const [printData, setPrintData] = useState<any>(null);

    const printRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        contentRef: printRef
    });

    const [variantDialogOpen, setVariantDialogOpen] = useState(false);
    const [editingVariant, setEditingVariant] = useState<any>(null);
    const [variants, setVariants] = useState<any[]>([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' | 'info' | 'warning' });

    const [imagePreview, setImagePreview] = useState("");

    const [categories, setCategories] = useState<any[]>([]);
    const [openCategoryModal, setOpenCategoryModal] = useState(false);

    const location = useLocation();
const from = location.state?.from;

    const { createProduct, updateProduct, getProduct, loading } = useProduct();

    const formMethods = useForm({
        mode: "onChange",
        defaultValues: {
            name: "", item_code: "", item_type: "product", category_id: "", brand: "", unit: "",
            hsn_sac: "", tax_type: "GST", gst_percent: 0, cess_percent: 0,
            purchase_price: 0, sale_price: 0, mrp: 0, min_sale_price: 0,
            track_stock: true, allow_negative_stock: false, reorder_level: 0,
            has_variants: false, image_url: "", notes: "", status: "active",WholeSalePrice: 0,DealerPrice: 0,CustomPrice: 0,DiscountedPrice: 0,
            ItemImage: null as FileList | null,
        },
    });

    const { control, handleSubmit, watch, setValue, getValues, reset, formState: { isDirty, isValid } } = formMethods;
    const hasVariants = watch('has_variants');

    useEffect(() => {
        if (isEditMode && id) {
            getProduct(id);
            fetchCategories();
        }
    }, [id]);

    useEffect(() => {
        if (!id) return;

        const fetchProduct = async () => {
            try {
                const resp: any = await callAPI(`Vyapar/Product/${id}`, Method.GET);

                const product = resp?.data ?? resp;

                if (!product) return;


                // Map API response → Form fields
                reset({
                    name: product.name || "",
                    item_code: product.itemCode || "",
                    item_type: "product",
                    category_id: product.categoryId || "",
                    brand: product.brand || "",
                    unit: product.unit || "",
                    hsn_sac: product.hsnSac || "",
                    tax_type: product.taxType || "GST",
                    gst_percent: product.gstPercent || 0,
                    cess_percent: product.cessPercent || 0,
                    purchase_price: product.purchasePrice || 0,
                    sale_price: product.salePrice || 0,
                    mrp: product.mrp || 0,
                    min_sale_price: product.minSalePrice || 0,
                    WholeSalePrice: product.wholeSalePrice || 0,
                    DealerPrice: product.dealerPrice || 0,
                    CustomPrice: product.customPrice || 0,
                    DiscountedPrice: product.discountedPrice || 0,
                    track_stock: product.trackStock ?? true,
                    allow_negative_stock: product.allowNegativeStock ?? false,
                    reorder_level: product.reorderLevel || 0,
                    has_variants: product.hasVariants ?? false,
                    image_url: product.imageUrl || "",
                    notes: product.notes || "",
                    status: product.status.toLowerCase() || "",
                    
                });
                if (product.imageUrl) {
                    setImagePreview(config.imgUrl + product.imageUrl);
                }


                // Load variants
                if (product.itemVariants && product.itemVariants.length > 0) {

                    const mappedVariants = product.itemVariants.map((v: any) => ({
                        variant_code: v.variantCode,
                        size: v.size,
                        color: v.color,
                        other1: v.other1,
                        stock_qty: v.stockQty,
                        status: v.status.toLowerCase() || "",
                    }));

                    setVariants(mappedVariants);
                }

            } catch (error) {
                console.error("Failed to fetch product:", error);
                showSnackbar("Failed to load product", "error");
            }
        };

        fetchProduct();

    }, [id, reset]);

    const showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSaveAndPrint = () => {
        // setPrintAfterSave(true);
        handleSubmit(() => onSubmit({}, true))();
    };

    const onSubmit = async (data: any, isPrint = false) => {
        try {
            const formData = new FormData();

            // 1. BASIC FIELDS - WORKING (keep exactly as before)
            formData.append("Name", data.name || "");
            formData.append("ItemCode", data.item_code || "");
            formData.append("ItemTypeNew", "1");
            formData.append("CategoryId", data.category_id);
            formData.append("Brand", data.brand || "");
            formData.append("Unit", data.unit || "");
            formData.append("HsnSac", data.hsn_sac || "");
            formData.append("TaxType", data.tax_type || "");
            formData.append("GstPercent", data.gst_percent?.toString() || "0");
            formData.append("CessPercent", data.cess_percent?.toString() || "0");
            formData.append("PurchasePrice", data.purchase_price?.toString() || "0");
            formData.append("SalePrice", data.sale_price?.toString() || "0");
            formData.append("Mrp", data.mrp?.toString() || "0");
            formData.append("MinSalePrice", data.min_sale_price?.toString() || "0");
            formData.append("WholeSalePrice", data.WholeSalePrice?.toString() || "0");
            formData.append("DealerPrice", data.DealerPrice?.toString() || "0");
            formData.append("CustomPrice", data.CustomPrice?.toString() || "0");
            formData.append("DiscountedPrice", data.DiscountedPrice?.toString() || "0");
            formData.append("TrackStock", data.track_stock.toString());
            formData.append("AllowNegativeStock", data.allow_negative_stock.toString());
            formData.append("ReorderLevel", data.reorder_level?.toString() || "0");
            formData.append("HasVariants", data.has_variants.toString());
            formData.append("Notes", data.notes || "");
            formData.append("Status", data.status || "");
            

            // 2. IMAGE UPLOAD - FULL FALLBACK SYSTEM (RESTORED)
            let imageFile: File | null = null;

            // Method 1: Direct ref (primary)
            if (imageRef.current?.files?.[0]) {
                imageFile = imageRef.current.files[0];
            }

            // Method 2: Form values fallback
            if (!imageFile) {
                const formImage = getValues('ItemImage') as FileList | File | null;
                if (formImage && (formImage as FileList)[0]) {
                    imageFile = (formImage as FileList)[0];
                }
            }

            // Method 3: DOM query fallback (CRITICAL)
            if (!imageFile) {
                const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
                if (fileInput?.files?.[0]) {
                    imageFile = fileInput.files[0];
                }
            }

            if (imageFile) {
                formData.append("ImageUrl", imageFile);
            }

            if (data.has_variants && variants.length > 0) {
                variants.forEach((v: any, index: number) => {

                    formData.append(`Variants[${index}].VariantCode`, v.variant_code || "");
                    formData.append(`Variants[${index}].Size`, v.size || "");
                    formData.append(`Variants[${index}].Color`, v.color || "");
                    formData.append(`Variants[${index}].StockQty`, v.stock_qty || "");
                    formData.append(`Variants[${index}].Other1`, v.other1 || "");
                    formData.append(
                        `Variants[${index}].Status`,
                        v.status === "active" ? "Active" : "Inactive"
                    );
                });
            }
            let response;

            // 5. API CALLS (unchanged - working)
            if (isEditMode && id) {

                response = await callAPI(
                    `Vyapar/Product/${id}`,
                    Method.PUT,
                    formData
                );
                showSnackbar("Product updated successfully", "success");

            } else {

                response = await callAPI(
                    `Vyapar/Product`,
                    Method.POST,
                    formData
                );

                const barcode = (response as any)?.data?.barcode;
                const name = (response as any)?.data?.productName;

                showSnackbar("Product created successfully", "success");

                if (barcode) {
                    setPrintData({
                        barcode,
                        name
                    });

                    setTimeout(() => {
                        handlePrint();
                    }, 300);
                }
            }

            // if (response.success) {

            //     // Check which action to perform
            //     if (isPrint) {
            //         handlePrint(request);
            //     }
            //     // else {
            //     //     navigate('/products/list');
            //     // }
            // }


          if (response?.success) {
  if (from === "expense") {
    navigate("/expense");
  } else if (from === "purchase") {
    navigate("/purchase");
  } else {
    navigate("/products/list");
  }
}
        } catch (error: any) {
            console.error("SUBMIT ERROR:", error);
            showSnackbar(error.response?.data?.message || "Failed to save product", "error");
        }
    };


    const handleAddVariant = () => {
        setEditingVariant(null);
        setVariantDialogOpen(true);
    };

    const handleEditVariant = (variant: any) => {
        setEditingVariant(variant);
        setVariantDialogOpen(true);
    };

    const handleDeleteVariant = (variantCode: string) => {
        setVariants(variants.filter(v => v.variant_code !== variantCode));
        showSnackbar('Variant deleted', 'info');
    };

    const handleSaveVariant = (variantData: any) => {
        if (editingVariant) {
            setVariants(variants.map(v => v.variant_code === editingVariant.variant_code ? variantData : v));
            showSnackbar('Variant updated', 'success');
        } else {
            const newVariant = { ...variantData, variant_code: `V${Date.now()}` };
            setVariants([...variants, newVariant]);
            showSnackbar('Variant added', 'success');
        }
        setVariantDialogOpen(false);
        setEditingVariant(null);
    };

    const categorySource = {
        url: "Vyapar/Category/search",
        page: 1,
        pageSize: 100000,
        filter: [],
        sort: []
    };

    const fetchCategories = async () => {
        try {
            const response = await callAPI("Vyapar/Category/search", Method.POST, {
                page: 1,
                pageSize: 1000,
                filter: "",
                sort: ""
            });

            if (response?.success) {
                // ✅ Filter out null/invalid categories
                const validCategories = (response.data?.results || response.data || [])
                    .filter((cat: any) => cat && cat.categoryName);
                setCategories(validCategories);
            }
        } catch (error) {
            console.error("Failed to fetch categories:", error);
            setCategories([]);  // ✅ Reset to empty on error
        }
    };


    const handleAddNewCategory = async (categoryName: string) => {
        try {
            const response = await callAPI("Vyapar/Category", Method.POST, {
                categoryName: categoryName,
            });

            if (response?.success) {
                // ✅ Backend created it - add to local state for chips
                // Refresh list to get real data + proper ID
                const tempCategory = {
                    id: `temp-${Date.now()}`,  // Temporary until refetch
                    categoryName: categoryName
                };

                setCategories(prev => [...prev, tempCategory]);
                showSnackbar("Category added successfully!", "success");

                // ✅ Refetch to sync with backend (gets real ID)
                setTimeout(() => {
                    fetchCategories();
                }, 300);

            } else {
                showSnackbar(response?.message || "Failed to create", "error");
            }
        } catch (error: any) {
            showSnackbar(error?.message || "Network error", "error");
        } finally {
            setOpenCategoryModal(false);
        }
    };

    const transFormData = (data: any) => {
        return data.map((item: any) => ({
            label: item.categoryName,
            value: item.id
        }));
    };

    return (
        <Box sx={{ p: 3 }}>
            <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
                <WSHeaderCard
                    header={isEditMode ? 'Edit Product' : 'Add New Product'}
                    subHeader="Manage product information and variants"
                    showBackButton={true}
                    gradient={true}
                    actions={
                        <>
                            <WSButton
                                id="cancelBtn"
                                variant="outlined"
                                color="error"
                                size="small"
                                label="Cancel"
                                startIcon={<CancelIcon />}
                                onClick={() => navigate('/products/list')}
                            />

                            <WSButton
                                id="saveAndPrintBtn"
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<PrintIcon />}
                                label="Save & Print"
                                onClick={handleSaveAndPrint}
                            />

                            <WSButton
                                id="saveBtn"
                                variant="contained"
                                color="primary"
                                size="small"
                                type="submit"
                                startIcon={<SaveIcon />}
                                loading={loading}
                                label={'Save'}
                            />
                        </>
                    }
                />

                <Grid container spacing={3}>
                    {/* Left Column - Main Product Information */}
                    <Grid item xs={12} lg={8}>
                        {/* Product Information Card */}
                        <Card
                            elevation={0}
                            sx={{
                                mb: 3,
                                borderRadius: 3,
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            }}
                        >
                            <CardHeader
                                title={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), width: 32, height: 32 }}>
                                            <LocalOfferIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
                                        </Avatar>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Information</Typography>
                                    </Box>
                                }
                                sx={{
                                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                    bgcolor: alpha(theme.palette.background.default, 0.5),
                                    py: 2,
                                }}
                            />
                            <CardContent sx={{ p: 3 }}>
                                <Grid container spacing={3}>
                                    {/* Product Name & SKU */}
                                    <Grid item xs={12} md={6}>
                                        <WSTextField
                                            id="name-field"
                                            name="name"
                                            rules={{ required: "Product name is required" }}
                                            label="Product Name"
                                            control={control}

                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: 2,
                                                    '&:hover': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: theme.palette.primary.main,
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <WSTextField
                                            id="item-code-field"
                                            name="item_code"
                                            rules={{ required: "Item code is required" }}
                                            label="Item Code / SKU"
                                            control={control}
                                            suffix={<QrCodeIcon sx={{ color: theme.palette.text.secondary, mr: 1, fontSize: 20 }} />}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: 2,
                                                },
                                            }}
                                        />
                                    </Grid>

                                    {/* Item Type & Category */}
                                    <Grid item xs={12} md={6}>
                                        <WSSelectField
                                            id="item-type-field"
                                            name="item_type"
                                            label="Item Type"
                                            control={control}
                                            options={[
                                                { value: "product", label: "Product" },
                                                // { value: "service", label: "Service" },
                                                // { value: "bundle", label: "Bundle" },
                                            ]}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        {/* 🔥 Wrap select + button */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                            }}
                                        >
                                            {/* Select Field */}
                                            <Box sx={{ flex: 1 }}>
                                                <WSSelectField
                                                    key={categories.length}
                                                    id="category-field"
                                                    name="categoryid"
                                                    label="Category"
                                                    control={control}
                                                    source={categorySource}
                                                    transFormData={(data: any) =>
                                                        data.map((item: any) => ({
                                                            label: item.categoryName,
                                                            value: item.id,
                                                        }))
                                                    }
                                                />
                                            </Box>

                                            {/* ✅ PLUS BUTTON ON RIGHT */}
                                            <Box
                                                onClick={() => setOpenCategoryModal(true)}
                                                sx={{
                                                    height: "38px", // match MUI input height
                                                    width: "38px",
                                                    borderRadius: "12px",
                                                    background: "#f3f3f3",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                        background: "#e0e0e0",
                                                    },
                                                }}
                                            >
                                                <AddIcon />
                                            </Box>
                                        </Box>

                                        {/* ✅ Chips section BELOW */}
                                        <Box

                                        >
                                            {categories
                                                ?.filter((cat) => cat && cat.categoryName)
                                                .map((cat: any) => (
                                                    <Chip
                                                        key={cat.id || cat.categoryName}
                                                        label={cat.categoryName || "Unnamed"}
                                                    />
                                                ))}
                                        </Box>
                                    </Grid>

                                    {/* Brand & Unit */}
                                    <Grid item xs={12} md={6}>
                                        <WSTextField
                                            id="brand-field"
                                            name="brand"
                                            label="Brand"
                                            control={control}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <WSTextField
                                            id="unit-field"
                                            name="unit"
                                            label="Unit (PCS, KG, Meter)"
                                            control={control}
                                        />
                                    </Grid>

                                    {/* HSN & Tax Information */}
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }}>
                                            <Chip
                                                label="Tax Information"
                                                size="small"
                                                sx={{
                                                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                                                    color: theme.palette.primary.main,
                                                    fontWeight: 500,
                                                }}
                                            />
                                        </Divider>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <WSTextField
                                            id="hsn-sac-field"
                                            name="hsn_sac"
                                            label="HSN / SAC Code"
                                            control={control}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <WSRadioField
                                            id="tax-type-field"
                                            name="tax_type"
                                            label="Tax Type"
                                            control={control}
                                            rules={{ required: true }}
                                            options={[
                                                { value: "GST", label: "GST" },
                                                { value: "EXEMPT", label: "Exempt" },
                                                { value: "NON_GST", label: "Non-GST" },
                                                { value: "Exclusive", label: "Exclusive" },
                                                { value: "NIL", label: "NIL" },
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <WSTextField
                                            id="gst-percent-field"
                                            name="gst_percent"
                                            label="GST Percentage"
                                            type={TextType.Number}
                                            control={control}
                                            rules={{ min: 0, max: 100 }}
                                            suffix={"%"}
                                        />
                                    </Grid>

                                    {/* Pricing Information */}
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }}>
                                            <Chip
                                                label="Pricing Information"
                                                size="small"
                                                sx={{
                                                    bgcolor: alpha(theme.palette.success.main, 0.1),
                                                    color: theme.palette.success.main,
                                                    fontWeight: 500,
                                                }}
                                            />
                                        </Divider>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="purchase-price-field"
                                            name="purchase_price"
                                            label="Purchase Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="sale-price-field"
                                            name="sale_price"
                                            label="Sale Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: "Sale Price is required", min: 0 }}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="mrp-field"
                                            name="mrp"
                                            label="MRP"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: "MRP is required", min: 0 }}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="min-sale-price-field"
                                            name="min_sale_price"
                                            label="Min Sale Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="WholeSalePrice"
                                            name="WholeSalePrice"
                                            label="Whole Sale Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="DealerPrice"
                                            name="DealerPrice"
                                            label="Dealer Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="CustomPrice"
                                            name="CustomPrice"
                                            label="Custom Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <WSTextField
                                            id="DiscountedPrice"
                                            name="DiscountedPrice"
                                            label="Discounted Price"
                                            type={TextType.Currency}
                                            currency={CurrencyType.Rupee}
                                            control={control}
                                            rules={{ required: true, min: 0 }}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* Additional Information Card */}
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            }}
                        >
                            <CardHeader
                                title={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Avatar sx={{ bgcolor: alpha(theme.palette.info.main, 0.1), width: 32, height: 32 }}>
                                            <AssessmentIcon sx={{ color: theme.palette.info.main, fontSize: 18 }} />
                                        </Avatar>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Additional Information</Typography>
                                    </Box>
                                }
                                sx={{
                                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                    bgcolor: alpha(theme.palette.background.default, 0.5),
                                    py: 2,
                                }}
                            />
                            <CardContent sx={{ p: 3 }}>
                                <WSTextAreaField
                                    id="notes-field"
                                    name="notes"
                                    label="Notes"
                                    rows={4}
                                    control={control}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Right Column - Status, Image, Variants */}
                    <Grid item xs={12} lg={4}>
                        {/* Status Card */}
                        <Card
                            elevation={0}
                            sx={{
                                mb: 3,
                                borderRadius: 3,
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Badge color="success" variant="dot" />
                                    Product Status
                                </Typography>
                                <WSRadioField
                                    id="status-field"
                                    name="status"
                                    control={control}
                                    rules={{ required: true }}
                                    options={[
                                        { value: "active", label: "Active" },
                                        { value: "inactive", label: "Inactive" },
                                    ]}

                                />
                            </CardContent>
                        </Card>

                        {/* Image Upload Card */}
                        <Card
                            elevation={0}
                            sx={{
                                mb: 3,
                                borderRadius: 3,
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <ImageIcon sx={{ color: theme.palette.primary.main }} />
                                    Product Image
                                </Typography>
                                <WSImageUpload
                                    control={control}
                                    id="ItemImage"
                                    name="ItemImage"
                                    label="Click to upload image"
                                    rules={{ required: false }}
                                    imgUrl={imagePreview}
                                />
                            </CardContent>
                        </Card>

                        {/* Variants Toggle Card */}
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                bgcolor: hasVariants ? alpha(theme.palette.primary.main, 0.02) : 'transparent',
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Variants</Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                            Enable for products with size, color, etc.
                                        </Typography>
                                    </Box>
                                    <Switch
                                        checked={hasVariants}
                                        onChange={(e) => setValue('has_variants', e.target.checked)}
                                        color="primary"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: theme.palette.primary.main,
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: alpha(theme.palette.primary.main, 0.5),
                                            },
                                        }}
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Variants Section */}
                    {hasVariants && (
                        <Grid item xs={12}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: 3,
                                    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                    mt: 2,
                                }}
                            >
                                <CardHeader
                                    title={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Avatar sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), width: 32, height: 32 }}>
                                                <InventoryIcon sx={{ color: theme.palette.secondary.main, fontSize: 18 }} />
                                            </Avatar>
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Variants</Typography>
                                        </Box>
                                    }
                                    action={
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={handleAddVariant}
                                            size="small"
                                            sx={{
                                                borderRadius: 2,
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
                                                '&:hover': {
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: `0 6px 15px ${alpha(theme.palette.primary.main, 0.3)}`,
                                                },
                                            }}
                                        >
                                            Add Variant
                                        </Button>
                                    }
                                    sx={{
                                        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                                        bgcolor: alpha(theme.palette.background.default, 0.5),
                                        py: 2,
                                    }}
                                />
                                <CardContent sx={{ p: 3 }}>
                                    {variants.length > 0 ? (
                                        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                                            <Table>
                                                <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
                                                    <TableRow>
                                                        <TableCell>Variant Code</TableCell>
                                                        <TableCell>Size</TableCell>
                                                        <TableCell>Color</TableCell>
                                                        <TableCell>Other Attribute</TableCell>
                                                        <TableCell align="center">Status</TableCell>
                                                        <TableCell align="center">Actions</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {variants.map((row: any, index: number) => (
                                                        <TableRow key={row.variant_code || index} hover>
                                                            <TableCell>
                                                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                    {row.variant_code}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Chip
                                                                    icon={<SizeIcon fontSize="small" />}
                                                                    label={row.size || 'N/A'}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    sx={{ borderRadius: 1 }}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    {row.color && (
                                                                        <Box
                                                                            sx={{
                                                                                width: 16,
                                                                                height: 16,
                                                                                borderRadius: '50%',
                                                                                bgcolor: row.color.toLowerCase(),
                                                                                border: '1px solid #ccc',
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <Typography variant="body2">{row.color || 'N/A'}</Typography>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography variant="body2">{row.other1 || 'N/A'}</Typography>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Chip
                                                                    label={row.status}
                                                                    color={row.status === 'active' ? 'success' : 'default'}
                                                                    size="small"
                                                                    sx={{
                                                                        minWidth: 60,
                                                                        fontWeight: 500,
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Stack direction="row" spacing={1} justifyContent="center">
                                                                    <Tooltip title="Edit Variant">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleEditVariant(row)}
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.1) }
                                                                            }}
                                                                        >
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Delete Variant">
                                                                        <IconButton
                                                                            size="small"
                                                                            color="error"
                                                                            onClick={() => handleDeleteVariant(row.variant_code)}
                                                                            sx={{
                                                                                '&:hover': { bgcolor: alpha(theme.palette.error.main, 0.1) }
                                                                            }}
                                                                        >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Stack>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    ) : (
                                        <Paper
                                            sx={{
                                                p: 6,
                                                textAlign: 'center',
                                                bgcolor: alpha(theme.palette.primary.main, 0.02),
                                                borderRadius: 2,
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    width: 80,
                                                    height: 80,
                                                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                                                    mx: 'auto',
                                                    mb: 2,
                                                }}
                                            >
                                                <InventoryIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                                            </Avatar>
                                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                                No Variants Added
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400, mx: 'auto' }}>
                                                Add variants for products that come in different sizes, colors, or other attributes.
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                startIcon={<AddIcon />}
                                                onClick={handleAddVariant}
                                                sx={{
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Add First Variant
                                            </Button>
                                        </Paper>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                </Grid>
            </form>

            <CategoryModal
                open={openCategoryModal}
                onClose={() => setOpenCategoryModal(false)}
                onSave={handleAddNewCategory}
            />

            <VariantDialog
                open={variantDialogOpen}
                onClose={() => setVariantDialogOpen(false)}
                onSave={handleSaveVariant}
                editData={editingVariant}
            />

            <div style={{ display: "none" }}>
                {printData && (
                    <BarcodePrintLabel
                        ref={printRef}
                        barcode={printData.barcode}
                        name={printData.name}
                    />
                )}
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Product;
